import { SxProps, Theme } from '@mui/material/styles';

export function gridWithSelectionList(showSelectionList: boolean, isMobile: boolean): SxProps {
  return {
    maxWidth: showSelectionList && !isMobile ? 'calc(100% - 384px)' : '100%',
    flexGrow: 1,
  };
}

export function selectionList(isMobile: boolean): SxProps {
  return {
    width: isMobile ? 'unset' : 360,
    maxWidth: '100%',
    margin: isMobile ? '16px 0 16px 0' : '0 0 0 24px',
  };
}

export const pageContainerWithFooter: SxProps = {
  padding: '0 32px 32px 32px',
};

export const summaryRow = { item: true, xs: 12, justifyContent: 'space-between', display: 'flex', p: 1.5 };

export const summaryButton = { width: '100%', maxWidth: '323px' };

export const visibleDrawerStyle = {
  '.MuiDrawer-root > .MuiPaper-root': {
    overflow: 'visible',
  },
};

export const pullableDrawer = {
  backgroundColor: 'background.paper',
  position: 'absolute',
  top: -40,
  borderTopLeftRadius: 8,
  borderTopRightRadius: 8,
  visibility: 'visible',
  right: 0,
  left: 0,
};

export const drawerPuller: SxProps<Theme> = (theme: Theme) => ({
  width: 80,
  height: 6,
  borderRadius: 3,
  backgroundColor: theme.palette.grey[300],
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 40px)',
});

export const alertFormField: SxProps = {
  color: 'warning.main',
  fontSize: '12px',
};

export const locationDataGridSx = (theme: Theme): SxProps<Theme> => ({
  '& .duplicate-cell .location-name-cell': {
    border: `2px solid ${theme.palette.error.main}`,
    display: 'flex',
    alignItems: 'center',
    borderRadius: '8px',
    margin: 'auto',
    padding: '0 16px',
    height: '40px',
  },
  '& .unassigned-location': {
    pointerEvents: 'none',
    '& .MuiDataGrid-rowReorderCell--draggable': {
      display: 'none',
    },
  },
  '& .MuiDataGrid-cell--editable': {
    boxShadow: 'none !important',
    outline: 'none !important',
    '&:focus-within': {
      outline: 'none !important',
    },
    '& .MuiDataGrid-editInputCell': {
      border: 'none !important',
      '&.Mui-focused': {
        border: 'none !important',
      },
      '& input': {
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: '8px',
        margin: '8px',
        padding: '0 16px',
        height: '40px',
        outline: 'none',
        '&:focus': {
          borderColor: theme.palette.primary.main,
          borderWidth: '2px',
          outline: 'none',
        },
      },
    },
    '&.duplicate-cell .MuiDataGrid-editInputCell input': {
      borderColor: theme.palette.error.main,
    },
  },
});

export const prepItemChipContainer = (theme: Theme): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  height: '24px',
  minHeight: '24px',
  maxHeight: '24px',
  borderRadius: '100px',
  padding: '0 8px',
  backgroundColor: theme.palette.category8.subtle,
  color: theme.palette.category8.subtleContrast,
  boxSizing: 'border-box',
  marginLeft: '8px',
  marginTop: '2px',
});

export const prepItemChipIcon = (theme: Theme): SxProps<Theme> => ({
  width: '18px',
  height: '18px',
  marginRight: '4px',
  fill: theme.palette.category8.main,
  color: theme.palette.category8.main,
});

export const prepItemChipText = (theme: Theme): SxProps<Theme> => ({
  fontSize: '12px',
  lineHeight: '20px',
  fontWeight: 500,
  whiteSpace: 'nowrap',
  color: theme.palette.category8.subtleContrast,
});

export const prepItemSelectionChip = (theme: Theme): SxProps<Theme> => ({
  backgroundColor: theme.palette.category8.subtle,
  color: theme.palette.category8.subtleContrast,
  '& .MuiChip-deleteIcon': {
    color: theme.palette.category8.subtleContrast,
  },
  '&:hover': {
    backgroundColor: theme.palette.category8.subtle,
  },
});

export const itemNameWithChipContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const groupingCellContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  '& .MuiDataGrid-treeDataGroupingCell': {
    width: 'auto',
  },
};

export const inventoryCardTitleContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'flex-start',
  gap: '8px',
  overflow: 'hidden',
};

export const inventoryCardTitleText: SxProps<Theme> = {
  fontWeight: '500',
  wordBreak: 'break-word',
};

export const inventoryCardActionContainer: SxProps<Theme> = {
  marginLeft: '8px',
};

export const inventoryCardReportingChip: SxProps<Theme> = {
  maxWidth: '140px',
};
